module.exports = __webpack_public_path__ + "static/media/logo.90e9aaf6.png";